<template>
  <div class="container">
    <div class="row">
      <div class="col-12 py-0">
        <div
          id="speed"
          class="container-fluid"
          style="align-content: center; align-items: center; text-align: center;"
        >
          <a name="GigaSpeed" />
          <div
            id="all_in_gbzone"
            class="row"
            style="margin-bottom: 10px; text-align: center;"
          >
            <div
              id="differences"
              class="col-12 text-center rounded-sm bg-color-light txt-color-dark p-4 my-3"
            >
              <a
                class="anchor"
                name="select-any-of-paul-bunyan-s-gigazone-speeds-and-compare-it-to-your-current-connection"
              /><h2
                class="mb-0"
              >
                Select any of Paul Bunyan's GigaZone speeds and compare it to your current
                connection
              </h2>
              <a
                class="anchor"
                name="the-is-times-faster"
              /><h2
                id="span_differences"
                class="hidden"
              >
                The <img
                  style="margin-bottom: -2px; height: 4rem;"
                  height="50"
                  width="auto"
                  src="/wp-content/uploads/2017/11/GigaZone-text-300.png"
                  alt="GigaZone"
                > is <span id="difference" /> times faster!
              </h2>
            </div>
          </div>
          <div class="d-flex w-100 row">
            <div class="form-group col-12 col-sm-4">
              <label for="size_selection">Select download type</label><br>
              <select
                id="size_selection"
                class="form-control"
              >
                <option value="7000">
                  4k movie 60 min long (~7Gb)
                </option>
                <option
                  selected="selected"
                  value="3000"
                >
                  HD movie 60 min long (~3Gb)
                </option>
                <option value="800">
                  SD movie 60 min long (~0.7Gb)
                </option>
                <option value="500">
                  100 pictures (~0.5Gb)
                </option>
                <option value="350">
                  100 Songs (~0.35Gb)
                </option>
                <option value="95">
                  Mobile Game (~0.095Gb)
                </option>
                <option value="5">
                  One Picture (~0.005Gb)
                </option>
              </select>
            </div>
            <div class="form-group col-12 col-sm-4">
              <label for="pb_selection">GigaZone Speeds:</label><br>
              <select
                id="pb_selection"
                class="form-control"
              >
                <option
                  value="10000"
                  selected="selected"
                >
                  10 Gb (10,000 Mb)
                </option>
                <option value="6000">
                  6 Gb (6,000 Mb)
                </option>
                <option value="2000">
                  2 Gb (2,000 Mb)
                </option>
                <option value="1000">
                  1 Gb (1,000 Mb)
                </option>
                <option value="250">
                  250 Mb
                </option>
              </select>
            </div>
            <div class="form-group col-12 col-sm-4">
              <label for="others_selection">Select your speed:</label><br>
              <select
                id="others_selection"
                name="others_selection"
                class="form-control"
              >
                <optgroup label="Cellphone Network Speeds">
                  <option value="0.0024">
                    ~0.0024 Mb (1G)
                  </option>
                  <option value="0.0144">
                    ~0.0144 Mb (2G)
                  </option>
                  <option value="3.6">
                    ~3.6 MB (3G)
                  </option>
                  <option value="14">
                    ~14 Mb (4G)
                  </option>
                  <option value="30">
                    ~30 Mb (4GLTE)
                  </option>
                  <option value="70">
                    ~70 Mb (5G)
                  </option>
                </optgroup>
                <optgroup label="Broadband Services">
                  <option value="1.5">
                    1.5 Mb
                  </option>
                  <option value="2">
                    2 Mb
                  </option>
                  <option value="7">
                    7 Mb
                  </option>
                  <option value="10">
                    10 Mb
                  </option>
                  <option value="15">
                    15 Mb
                  </option>
                  <option
                    value="20"
                    selected="selected"
                  >
                    20 Mb
                  </option>
                  <option value="50">
                    50 Mb
                  </option>
                  <option value="100">
                    100 Mb
                  </option>
                  <option value="150">
                    150 Mb
                  </option>
                  <option value="200">
                    200 Mb
                  </option>
                  <option value="250">
                    250 Mb
                  </option>
                </optgroup>
              </select>
            </div>
          </div>
          <div class="row my-5">
            <button
              id="go"
              class="btn btn-orange text-white"
              style="margin-left: auto; margin-right: auto; margin-top: 5px; width: 260px; color: rgb(0, 0, 0);"
            >
              Check
              out the difference!
            </button>
          </div>
          <div
            id="circle_group"
            class="row d-flex justify-content-around"
          >
            <div
              id="info1"
              class="col-12 col-md-6 col-lg-4 d-flex flex-col justify-content-start align-items-center"
              style="text-align: center;"
            >
              <strong
                id="info1Strong"
                class="font-color-black"
                style="display: flex; align-items: center; justify-content: center; text-align: center; width: 350px; max-width: 100%; height: 63px; min-height: 63px; max-height: 63px; overflow: hidden; font-weight: 900; font-size: 14px; line-height: 1.3;"
              />
              <div
                id="circle1"
                class="theCanvas"
                style="display: block; padding: 0; background-color: rgba(0, 0, 0, 0); border-radius: 0; text-align: center; align-content: center; height: 350px; width: 350px; background-image: url('/wp-content/plugins/speed-manager/images/gz.png'); background-size:contain; background-repeat: no-repeat;"
              />
              <div
                id="text1"
                class="p-md txt-center rounded-sm bg-color-light"
                style="font-weight: 900; color: red; font-size: 16px; text-align: center;"
              >
                The Largest and Fastest
                All-Fiber Optic Network in Northern Minnesota
              </div>
            </div>
            <div
              id="info2"
              class="col-12 col-md-6 col-lg-4 d-flex flex-col justify-content-start align-items-center"
            >
              <strong
                id="info2Strong"
                class="font-color-black"
                style="display: flex; align-items: center; justify-content: center; text-align: center; width: 350px; max-width: 100%; height: 63px; min-height: 63px; max-height: 63px; overflow: hidden; font-weight: 900; font-size: 14px; line-height: 1.3;"
              />
              <div
                id="circle2"
                class="theCanvas"
                style="display: block; padding: 0; background-color: rgba(0, 0, 0, 0); border-radius: 0; text-align: center; align-content: center; height: 350px; width: 350px; background-image: url('/wp-content/plugins/speed-manager/images/other.png'); background-size: contain; background-repeat: no-repeat;"
              />
              <div
                id="text2"
                class="p-md txt-center rounded-sm bg-color-light"
                style="font-weight: 900; color: red; font-size: 16px; text-align: center;"
              >
                Your Network Speed
              </div>
            </div>
          </div>
        </div>

        <!--
          Disclaimer ("To check the speed of your connection ...") is owned
          by the WordPress page content for /gigazone/gigazone-speed-comparison/,
          not by this component. Keeping it here was producing a duplicate
          on the live page.
        -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpeedTest',
};
</script>
